import { css } from '@emotion/css'
import { breakpoint, mediaQueryHelper, spacing } from '@offerzen/pinata-shame'

const styles = {
  body: css({
    [mediaQueryHelper(breakpoint.tablet, 'max-width')]: {
      padding: spacing.default,
    },
  }),
}

export default styles
